import React, { useState } from "react";
import { useUtils } from "@material-ui/pickers";
import { useApolloClient } from "@apollo/react-hooks";
import parseISO from "date-fns/parseISO";
import format from "date-fns/format";
import { useIntl } from 'react-intl';
import SelectDate from './select-date';
import Dialog from './dialog';
import { setDateToISOString } from '../../utils/utils';
import useTranslationQuery from '../../graphql/queries/change-language';

const Calendar = () => {
  const [start, setStart] = useState(false);
  const [end, setEnd] = useState(false);
  const [open, setOpen] = useState(false);
  const [init, setInit] = useState(false);

  const [startInput, setStartInput] = useState(false);
  const [endInput, setEndInput] = useState(false);
  const [error, setError] = useState('');

  const { formatMessage } = useIntl();
  const client = useApolloClient();

  const utils = useUtils();
  const { data } = useTranslationQuery();

  const handleOpen = () => setOpen(!open);

  const dateFormat = "MMM do yyyy";
  const dateFrFormat = "dd/MM/yyyy";
  const formatDate = date => utils.format(date, data && data.language === "FR"? dateFrFormat: dateFormat || utils.dateFormat);

  const handleChange = values => {
    setStart(values.start);
    setEnd(values.end);
  }

  const handleClick = (name, day) => {
    if (name === "start") setStartInput(day);
    if (name === "end") setEndInput(day);
  }

  const handleInputChange = (name, value) => {
      const formattedValue = format(new Date(value), data && data.language === "FR"? 'dd/MM/yy': 'MM/dd/yy');
      if (name === "start") setStartInput(new Date(formattedValue));
      if (name === "end") setEndInput(new Date(formattedValue));
  }

  const handleSubmit = () => {
    let startDateString;
    let endDateString;

    if (start) startDateString = setDateToISOString(start);
    if (end) endDateString = setDateToISOString(end);
    if (startInput) startDateString = setDateToISOString(new Date(startInput));
    if (endInput) endDateString = setDateToISOString(new Date(endInput));

    if (utils.isBefore(parseISO(endDateString), parseISO(startDateString))) {
      const message = formatMessage({id:"app.error.date", defaultMessage:"Start date must be before end date"});
      setError(message);
      return;
    }
    setError('');
    console.log("startDateString", startDateString);
    console.log("endDateString",endDateString);
    client.writeData({ data : { dateRange: { start: startDateString, end: endDateString, __typename: 'DateRange'} }});

    setOpen(false);
  }

  const handleCancel = () => {
    setStart(false);
    setEnd(false);
    setStartInput(false);
    setEndInput(false);
    setInit(true);
    setError('');
  }

  const handleClose = () => {
    setStart(false);
    setEnd(false);
    setStartInput(false);
    setEndInput(false);
    setInit(false);
    setOpen(false);
    setError('');
  }

  const onInit = () => setInit(false);

  return (
      <>
          <SelectDate 
              start={startInput || start}
              end={endInput || end}
              open={open}
              init={init}
              placeholder="From"
              onClick={handleOpen}
              formatDate={formatDate}
              language={data && data.language}
              utils={utils}
          />
          { open && (
            <Dialog 
                formatDate={formatDate}
                open={open}
                init={init}
                onChange={handleChange}
                start={startInput || start}
                end={endInput || end}
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                error={error}
                onInputChange={handleInputChange}
                onClick={handleClick}
                onClose={handleClose}
                onInit={onInit}
                language={data && data.language}
            />
          )}
      </>
  );
}

export default Calendar;